import { createTelemetry, createTelemetryObject } from '@shared/core/analytics';
import { PageFunctionType } from '@shared/core/analytics/telemetry/types';

const pagePrefix = 'admin.registry';

export type PagesForTelemetry = 'delayShippingEnableDialog' | 'delayShippingDisableDialog' | 'shipNowOrderConfirmationDialog' | 'shipAllOrdersConfirmationDialog';

const pages: { [tab in PagesForTelemetry]: PageFunctionType } = {
  delayShippingEnableDialog: () => ({
    category: 'delayShipping',
    pagePrefix,
    page: 'EnableConfirmationDialog'
  }),
  delayShippingDisableDialog: () => ({
    category: 'delayShipping',
    pagePrefix,
    page: 'DisableConfirmationDialog'
  }),
  shipNowOrderConfirmationDialog: () => ({
    category: 'tracker',
    pagePrefix,
    page: 'ShipNowOrderConfirmationDialog'
  }),
  shipAllOrdersConfirmationDialog: () => ({
    category: 'tracker',
    pagePrefix,
    page: 'ShipAllOrdersConfirmationDialog'
  })
};

export const delayShippingTelemetry = createTelemetryObject({
  actions: {
    toggleDelayShippingClicked: () => ({
      pagePrefix,
      category: 'delayShipping',
      action: 'ButtonInteracted',
      label: 'Delay shipping'
    }),
    toggleDelayShippingConfirmClicked: (toggle: 'enable' | 'disable') => ({
      pagePrefix,
      category: 'delayShipping',
      action: 'ButtonInteracted',
      label: 'Got it',
      extraInfo: {
        onChangeAction: toggle
      }
    }),
    shipNowConfirmationClicked: (orderId: string) => ({
      pagePrefix,
      category: 'tracker',
      action: 'ButtonInteracted',
      label: 'Ship Order Now',
      extraInfo: {
        orderId
      }
    }),
    shipNowClicked: (orderId: string) => ({
      pagePrefix,
      category: 'tracker',
      action: 'ButtonInteracted',
      label: 'Ship Order Now',
      extraInfo: {
        orderId
      }
    }),
    shipAllOrdersConfirmationClicked: (orderIds: string[]) => ({
      pagePrefix,
      category: 'tracker',
      action: 'ButtonInteracted',
      label: 'Ship All Orders',
      extraInfo: {
        orderIds,
        ordersCount: orderIds.length
      }
    }),
    reviewAndShipAllOrdersClicked: () => ({
      pagePrefix,
      category: 'tracker',
      action: 'ButtonInteracted',
      label: 'Review And Ship All Orders'
    })
  },
  pages
});

export const { TelemetryProvider, useTelemetry: useDelayShippingTelemetry } = createTelemetry(delayShippingTelemetry, { eventId: '' });
